import { render, staticRenderFns } from "./batchCustomerSetting.vue?vue&type=template&id=65e6e488&scoped=true&"
import script from "./batchCustomerSetting.vue?vue&type=script&lang=js&"
export * from "./batchCustomerSetting.vue?vue&type=script&lang=js&"
import style0 from "./batchCustomerSetting.vue?vue&type=style&index=0&id=65e6e488&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e6e488",
  null
  
)

export default component.exports